import { createFileRoute, redirect } from "@tanstack/react-router";

import { OwnerDashboardPage } from "@/modules/dashboard/pages/OwnerDashboard.page";

export const Route = createFileRoute("/__authed/m/dashboard/owner")({
	beforeLoad({ context }) {
		const user = "user" in context ? context.user : undefined;

		if (!user || user.role.slug !== "admin") {
			throw redirect({ to: "/m/dashboard" });
		}
	},
	component: OwnerDashboardPage,
});
